import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@src/components/shadcn/dropdown-menu';
import {SidebarFooter, SidebarMenuButton} from '@src/components/shadcn/sidebar';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown, faChevronUp, faUser} from '@fortawesome/pro-light-svg-icons';
import {NavItem} from './types';
import NavFooterDropdownContent from './NavFooterDropdownContent';

type SimpleLink = {
  absoluteRoot: string;
  relativePath: string;
  label: string;
};

const NavFooter = ({
  accountNavItems,
  catererInfo,
  backToAdminItem,
  logoutItem,
}: {
  accountNavItems: NavItem[];
  catererInfo: {email: string; name: string};
  backToAdminItem: SimpleLink | undefined;
  logoutItem: SimpleLink | undefined;
}) => {
  return (
    <SidebarFooter>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <SidebarMenuButton asChild>
            <div className="cursor-pointer bg-peppercorn-50 h-16 p-4 rounded flex items-center justify-between">
              <section className="flex items-center gap-2">
                <div className="bg-ezgreen-300 rounded h-8 w-8 flex justify-center items-center">
                  <FontAwesomeIcon
                    icon={faUser}
                    className="text-ezgreen-300 bg-white rounded-full w-4"
                  />
                </div>
                <div className="flex justify-center items-start flex-col">
                  <span className="text-base text-peppercorn-800 font-normal">
                    {catererInfo?.name}
                  </span>
                  <span className="text-xs text-peppercorn-400 font-normal">
                    {catererInfo?.email}
                  </span>
                </div>
              </section>
              <div className="flex flex-col">
                <FontAwesomeIcon className="text-xs text-peppercorn-800" icon={faChevronUp} />
                <FontAwesomeIcon className="text-xs text-peppercorn-800" icon={faChevronDown} />
              </div>
            </div>
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="rounded-lg w-56"
          align="end"
          sideOffset={-50}
          alignOffset={-180}
        >
          <NavFooterDropdownContent
            accountNavItems={accountNavItems}
            backToAdminItem={backToAdminItem}
            logoutItem={logoutItem}
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarFooter>
  );
};

export default NavFooter;
